const companionSearchFields = (companion = {}) => [
  companion.displayName,
  companion.username,
  companion.handle,
  companion.email,
].filter(Boolean);

export const companionMatchesSearch = (companion, query = '') => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) return true;

  return companionSearchFields(companion).some((field) =>
    String(field).toLowerCase().includes(normalizedQuery)
  );
};

export const filterCompanionsForInvitation = (companions = [], query = '') =>
  companions.filter((companion) => companionMatchesSearch(companion, query));
